import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconsModule } from '@monsido/angular-shared-components';
import { CommonModule } from '@angular/common';

@Component({
    selector: '[mon-favicon-wrapper-component], [monFaviconWrapperComponent]',
    templateUrl: './favicon-wrapper.component.html',
    styleUrls: ['./favicon-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IconsModule,
        CommonModule,
    ],
})
export class FaviconWrapperComponent {
    @Input() monSrc: string = '';
    @Input() monAlt: string = '';

    hasFailedFavicon = false;

    public onError (): void {
        this.hasFailedFavicon = true;
    }
}
